import {
  AeroplaneSVG,
  ApprovalSVG,
  BankSVG,
  BedSVG,
  BinocularSVG,
  BoatSVG,
  CardHolderSVG,
  NotePencilSVG,
  CircleDollarSVG,
  ProjectSVG,
  RoleSVG,
  TagSVG,
  UserSVG,
  WalletSVG,
  ChartLineSVG,
  UsersThreeSVG,
  UserSquareSVG,
  IdentificationBadgeSVG,
  ShuffleSVG,
  FoldersSVG,
  FilesSVG,
  WalletClockwiseIcon,
  BankClockwiseIcon,
  ReceiptSVG,
  ScrollSVG,
  ArchiveSVG,
  DepositSVG,
  RefundReleaseSVG,
  Receipt2SVG,
  SuitcaseSVG,
  WalletDocSVG,
  BankDocSVG,
  AeroplaneDocSVG,
  BedDocSVG,
  UserDocSVG,
  ChecksSVG,
  DollarTransactionSVG,
  ScrollDocSVG,
  ReceiptDocSVG,
  ArticlePencilSVG,
  SquareFourSVG,
  DollarSVG,
  PackageSVG,
} from 'common/assets';
import { AuthorizationRules, NavigationRoutes } from 'common/constants';
import { ApprovalList, ApprovalView } from 'legacy-modules/approval/approval';
import BonusPeriodCreate from 'legacy-modules/bonus-periods/create';
import BonusPeriodList from 'legacy-modules/bonus-periods/list';
import BonusPeriodView from 'legacy-modules/bonus-periods/view';
import ChangePassword from 'legacy-modules/change-password';
import CustomerRelationOfficer from 'legacy-modules/cro';
import DashboardGuestView from 'legacy-modules/dashboard/guest/view';
import { AgentCreate, AgentList, AgentView } from 'legacy-modules/master/agent';
import {
  ApprovalMasterCreate,
  ApprovalMasterList,
  ApprovalMasterView,
} from 'legacy-modules/master/approval';
import {
  CommissionCreate,
  CommissionList,
  CommissionView,
} from 'legacy-modules/master/commission';
import {
  CustomerCreate,
  CustomerList,
  CustomerView,
} from 'legacy-modules/master/customer';
import {
  EmployeeCreate,
  EmployeeList,
  EmployeeView,
} from 'legacy-modules/master/employee';
import { GuestCreate, GuestList, GuestView } from 'legacy-modules/master/guest';
import {
  PreferenceTagCreate,
  PreferenceTagList,
  PreferenceTagView,
} from 'legacy-modules/master/preference-tag';
import { RoleCreate, RoleList, RoleView } from 'legacy-modules/master/role';
import {
  VisaDocumentCreate,
  VisaDocumentView,
} from 'legacy-modules/master/visa-document';
import VisaDocumentList from 'legacy-modules/master/visa-document/list';
import {
  ActivityPurchaseCreate,
  ActivityPurchaseList,
  ActivityPurchaseView,
} from 'legacy-modules/order/activity';
import {
  CruisePurchaseCreate,
  CruisePurchaseList,
  CruisePurchaseView,
} from 'legacy-modules/order/cruise';
import {
  HotelOrderCreate,
  HotelOrderList,
  HotelOrderView,
} from 'legacy-modules/order/hotel';
import {
  TicketOrderCreate,
  TicketOrderList,
  TicketOrderView,
} from 'legacy-modules/order/ticket-order';
import {
  TravelDocumentOrderCreate,
  TravelDocumentOrderList,
  TravelDocumentOrderView,
} from 'legacy-modules/order/travel-document';
import {
  ProductAdjustmentCreate,
  ProductAdjustmentList,
  ProductAdjustmentView,
} from 'legacy-modules/product/adjustment';
import {
  ProductListCreate,
  ProductListList,
  ProductListView,
} from 'legacy-modules/product/list';
import {
  ProductOrderCreate,
  ProductOrderList,
  ProductOrderView,
} from 'legacy-modules/product/order';
import {
  ProductSaleCreate,
  ProductSaleList,
  ProductSaleView,
} from 'legacy-modules/product/sales';
import {
  ProjectCreate,
  ProjectList,
  ProjectView,
} from 'legacy-modules/projects';
import {
  RefundCreate,
  RefundList,
  RefundView,
} from 'legacy-modules/refund/refund';
import {
  RefundReleaseAgentList,
  RefundReleaseAgentView,
} from 'legacy-modules/refund/refund-release-agent';
import {
  RefundReleaseUserList,
  RefundReleaseUserView,
} from 'legacy-modules/refund/refund-release-user';
import {
  AccountPayableRegularReport,
  AccountPayableReport,
  AccountReceivableRegularReport,
  AccountReceivableReport,
  AgentMutationReport,
  BankMutationReport,
  CashMutationReport,
  CustomerMutationReport,
  FlightReport,
  HotelReport,
  PurchaseReport,
  SaleReport,
  TourReport,
} from 'legacy-modules/report';
import ApecCardReport from 'legacy-modules/report/apec-card';
import EmployeeCommissionReport from 'legacy-modules/report/employee-commission';
import IncomeReport from 'legacy-modules/report/income';
import IncomeStatementReport from 'legacy-modules/report/income-statement';
import InsuranceReport from 'legacy-modules/report/insurance';
import NonSalesBonusReport from 'legacy-modules/report/non-sales-bonus';
import PassportReport from 'legacy-modules/report/passport';
import ProjectListReport from 'legacy-modules/report/project-list';
import SalesBonusReport from 'legacy-modules/report/sales-bonus';
import ReportTourDetail from 'legacy-modules/report/tour-detail';
import TransactionReport from 'legacy-modules/report/transaction';
import VisaReport from 'legacy-modules/report/visa';
import {
  ActivitySaleCreate,
  ActivitySaleList,
  ActivitySaleView,
} from 'legacy-modules/sales/activity';
import {
  CruiseSaleCreate,
  CruiseSaleList,
  CruiseSaleView,
} from 'legacy-modules/sales/cruise';
import {
  HotelSaleCreate,
  HotelSaleList,
  HotelSaleView,
} from 'legacy-modules/sales/hotel';
import Reschedule from 'legacy-modules/sales/reschedule';
import {
  TicketSaleCreate,
  TicketSaleList,
  TicketSaleView,
} from 'legacy-modules/sales/ticket-sale';
import {
  TravelDocumentSalesCreate,
  TravelDocumentSalesList,
  TravelDocumentSalesView,
} from 'legacy-modules/sales/travel-document';
import { TourCreate, TourList, TourView } from 'legacy-modules/tour/tour-list';
import { TourSaleCreate, TourSaleView } from 'legacy-modules/tour/tour-sale';
import TourSalesList from 'legacy-modules/tour/tour-sale/list';
import {
  AccountPayableCreate,
  AccountPayableList,
  AccountPayableView,
} from 'legacy-modules/transactions/account-payable';
import {
  AccountReceivableCreate,
  AccountReceivableList,
  AccountReceivableView,
} from 'legacy-modules/transactions/account-receivable';
import {
  BalanceAdjustmentsCreate,
  BalanceAdjustmentsList,
  BalanceAdjustmentsView,
} from 'legacy-modules/transactions/balance-adjustment';
import {
  BankTransactionsCreate,
  BankTransactionsList,
  BankTransactionsView,
} from 'legacy-modules/transactions/bank-transaction';
import {
  CashTransactionsCreate,
  CashTransactionsList,
  CashTransactionsView,
} from 'legacy-modules/transactions/cash-transaction';
import {
  ChequeGiroClearingsList,
  ChequeGiroClearingsView,
} from 'legacy-modules/transactions/cheque-giro-clearing';
import {
  OrderAdjustmentCreate,
  OrderAdjustmentList,
  OrderAdjustmentView,
} from 'legacy-modules/transactions/order-adjustment';
import {
  ReceiptCreate,
  ReceiptList,
  ReceiptView,
} from 'legacy-modules/transactions/receipt';
import {
  TransfersList,
  TransfersCreate,
  TransfersView,
} from 'legacy-modules/transactions/transfer';
import BankAccountCreate from 'modules/finances/bank-account/create';
import BankAccountList from 'modules/finances/bank-account/list';
import BankAccountView from 'modules/finances/bank-account/view';
import CashAccountCreate from 'modules/finances/cash-account/create';
import CashAccountList from 'modules/finances/cash-account/list';
import CashAccountView from 'modules/finances/cash-account/view';
import ChequeGiroCreate from 'modules/finances/cheque-giro/create';
import ChequeGiroList from 'modules/finances/cheque-giro/list';
import ChequeGiroView from 'modules/finances/cheque-giro/view';
import PaymentChannelCreate from 'modules/finances/payment-channel/create';
import PaymentChannelList from 'modules/finances/payment-channel/list';
import PaymentChannelView from 'modules/finances/payment-channel/view';
import TransactionCategoryCreate from 'modules/finances/transaction-category/create';
import TransactionCategoryList from 'modules/finances/transaction-category/list';
import TransactionCategoryView from 'modules/finances/transaction-category/view';
import {
  ActivityCreate,
  ActivityList,
  ActivityView,
} from 'modules/services/activity';
import {
  AirlineCreate,
  AirlineList,
  AirlineView,
} from 'modules/services/airline';
import { CruiseCreate, CruiseList, CruiseView } from 'modules/services/cruise';
import { HotelCreate, HotelList, HotelView } from 'modules/services/hotel';
import TourCategoryCreate from 'modules/services/tour-category/create';
import TourCategoryList from 'modules/services/tour-category/list';
import TourCategoryView from 'modules/services/tour-category/view';

const routes = [
  {
    //TODO CHANGE ACL
    permission: AuthorizationRules.NoAuthorization,
    routeName: NavigationRoutes.GuestDashboardView,
    component: DashboardGuestView,
    title: 'common:guest',
    leftIcon: (color, size) => <SquareFourSVG {...{ color, size }} />,
  },
  {
    permission: AuthorizationRules.CroPage,
    routeName: NavigationRoutes.Cro,
    component: CustomerRelationOfficer,
    title: 'navigation:cro',
    leftIcon: (color, size) => <ProjectSVG {...{ color, size }} />,
  },
  {
    permission: AuthorizationRules.ApprovalItemsPage,
    routeName: NavigationRoutes.ApprovalItemsList,
    component: ApprovalList,
    title: 'common:approval',
    leftIcon: (color, size) => <ApprovalSVG {...{ color, size }} />,
  },

  {
    title: 'common:sale',
    children: [
      {
        permission: AuthorizationRules.FlightSalesPage,
        routeName: NavigationRoutes.TicketSalesList,
        component: TicketSaleList,
        title: 'common:flight_ticket',
        leftIcon: (color, size) => <AeroplaneSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.HotelSalesPage,
        routeName: NavigationRoutes.HotelSalesList,
        component: HotelSaleList,
        title: 'common:hotel',
        leftIcon: (color, size) => <BedSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.CruiseSalesPage,
        routeName: NavigationRoutes.CruiseSalesList,
        component: CruiseSaleList,
        title: 'common:cruise',
        leftIcon: (color, size) => <BoatSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.DocumentSalesPage,
        routeName: NavigationRoutes.TravelDocumentSalesList,
        component: TravelDocumentSalesList,
        title: 'common:travel_document',
        leftIcon: (color, size) => <FoldersSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ActivitySalesPage,
        routeName: NavigationRoutes.ActivitySalesList,
        component: ActivitySaleList,
        title: 'common:other',
        leftIcon: (color, size) => <BinocularSVG {...{ color, size }} />,
      },
    ],
  },

  {
    title: 'common:order',
    children: [
      {
        permission: AuthorizationRules.FlightPurchasesPage,
        routeName: NavigationRoutes.FlightPurchasesList,
        component: TicketOrderList,
        title: 'common:flight_ticket',
        leftIcon: (color, size) => <AeroplaneSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.HotelPurchasesPage,
        routeName: NavigationRoutes.HotelPurchasesList,
        component: HotelOrderList,
        title: 'common:hotel',
        leftIcon: (color, size) => <BedSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.CruisePurchasesPage,
        routeName: NavigationRoutes.CruisePurchasesList,
        component: CruisePurchaseList,
        title: 'common:cruise',
        leftIcon: (color, size) => <BoatSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.DocumentPurchasesPage,
        routeName: NavigationRoutes.DocumentPurchasesList,
        component: TravelDocumentOrderList,
        title: 'common:travel_document',
        leftIcon: (color, size) => <FoldersSVG {...{ color, size }} />,
      },

      {
        permission: AuthorizationRules.ActivityPurchasesPage,
        routeName: NavigationRoutes.ActivityPurchasesList,
        component: ActivityPurchaseList,
        title: 'common:other',
        leftIcon: (color, size) => <BinocularSVG {...{ color, size }} />,
      },
    ],
  },

  {
    title: 'common:tour',
    children: [
      {
        permission: AuthorizationRules.ToursPage,
        routeName: NavigationRoutes.TourList,
        component: TourList,
        title: 'common:tour_list',
        leftIcon: (color, size) => <SuitcaseSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.TourSalesPage,
        routeName: NavigationRoutes.TourSalesList,
        component: TourSalesList,
        title: 'common:tour_sale',
        leftIcon: (color, size) => <ChartLineSVG {...{ color, size }} />,
      },
    ],
  },

  //product
  {
    title: 'common:product',
    children: [
      {
        permission: AuthorizationRules.ProductsPage,
        routeName: NavigationRoutes.ProductsList,
        component: ProductListList,
        title: 'common:product_list',
        leftIcon: (color, size) => <ArchiveSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ProductSalesPage,
        routeName: NavigationRoutes.ProductSalesList,
        component: ProductSaleList,
        title: 'common:product_sales',
        leftIcon: (color, size) => <ChartLineSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ProductPurchasesPage,
        routeName: NavigationRoutes.ProductPurchasesList,
        component: ProductOrderList,
        title: 'common:product_purchase',
        leftIcon: (color, size) => <DepositSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ProductAdjustmentsList,
        routeName: NavigationRoutes.ProductAdjustmentList,
        component: ProductAdjustmentList,
        title: 'common:product_adjustments',
        leftIcon: (color, size) => <PackageSVG {...{ color, size }} />,
      },
    ],
  },

  // travel document
  {
    permission: AuthorizationRules.VisaDocumentsPage,
    routeName: NavigationRoutes.VisaDocumentList,
    component: VisaDocumentList,
    title: 'common:visa-document',
    leftIcon: (color, size) => <FilesSVG {...{ color, size }} />,
  },

  // project
  {
    permission: AuthorizationRules.ProjectsPage,
    routeName: NavigationRoutes.ProjectList,
    component: ProjectList,
    title: 'common:project_list',
    leftIcon: (color, size) => <ProjectSVG {...{ color, size }} />,
  },

  //refund
  {
    title: 'common:refund',
    children: [
      {
        permission: AuthorizationRules.RefundsPage,
        routeName: NavigationRoutes.RefundList,
        component: RefundList,
        title: 'common:refund',
        leftIcon: (color, size) => <RefundReleaseSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReleaseSalesPage,
        routeName: NavigationRoutes.RefundReleaseUserList,
        component: RefundReleaseUserList,
        title: 'common:refund_release_user',
        leftIcon: (color, size) => <RefundReleaseSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReleasePurchasesPage,
        routeName: NavigationRoutes.RefundReleaseAgentList,
        component: RefundReleaseAgentList,
        title: 'common:refund_release_agent',
        leftIcon: (color, size) => <RefundReleaseSVG {...{ color, size }} />,
      },
    ],
  },
  {
    title: 'common:transaction',
    children: [
      {
        permission: AuthorizationRules.AccountPayablesPage,
        routeName: NavigationRoutes.AccountPayablesList,
        component: AccountPayableList,
        title: 'common:account_payable',
        leftIcon: (color, size) => <ReceiptSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.AccountReceivablesPage,
        routeName: NavigationRoutes.AccountReceivablesList,
        component: AccountReceivableList,
        title: 'common:account_receivable',
        leftIcon: (color, size) => <ScrollSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReceiptsPage,
        routeName: NavigationRoutes.ReceiptsList,
        component: ReceiptList,
        title: 'common:receipt',
        leftIcon: (color, size) => <Receipt2SVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ChequeNotesPage,
        routeName: NavigationRoutes.ChequeGiroClearingsList,
        component: ChequeGiroClearingsList,
        title: 'common:cheque_giro_clearing',
        leftIcon: (color, size) => <FilesSVG {...{ color, size }} />,
      },

      {
        permission: AuthorizationRules.BalanceAdjustmentsPage,
        routeName: NavigationRoutes.BalanceAdjustmentsList,
        component: BalanceAdjustmentsList,
        title: 'common:balance_adjustment',
        leftIcon: (color, size) => <CircleDollarSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.TransfersPage,
        routeName: NavigationRoutes.TransfersList,
        component: TransfersList,
        title: 'common:transfer',
        leftIcon: (color, size) => <ShuffleSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.CashTransactionsPage,
        routeName: NavigationRoutes.CashTransactionsList,
        component: CashTransactionsList,
        title: 'common:cash_transaction',
        leftIcon: (color, size) => <WalletClockwiseIcon {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.BankTransactionsPage,
        routeName: NavigationRoutes.BankTransactionsList,
        component: BankTransactionsList,
        title: 'common:bank_transaction',
        leftIcon: (color, size) => <BankClockwiseIcon {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.OrderAdjustmentsPage,
        routeName: NavigationRoutes.OrderAdjustmentList,
        component: OrderAdjustmentList,
        title: 'common:order_adjustment',
        leftIcon: (color, size) => <ArticlePencilSVG {...{ color, size }} />,
      },
    ],
  },

  {
    title: 'common:report',
    children: [
      {
        permission: AuthorizationRules.ReportsSale,
        routeName: NavigationRoutes.SaleReport,
        component: SaleReport,
        title: 'common:sales_report',
        leftIcon: (color, size) => <ChartLineSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsPurchase,
        routeName: NavigationRoutes.PurchaseReport,
        component: PurchaseReport,
        title: 'common:purchase_report',
        leftIcon: (color, size) => <DepositSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsAccountReceivable,
        routeName: NavigationRoutes.AccountReceivableReport,
        component: AccountReceivableReport,
        title: 'common:account_receivable_report',
        leftIcon: (color, size) => <ScrollSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsAccountReceivableRegular,
        routeName: NavigationRoutes.AccountReceivableRegularReport,
        component: AccountReceivableRegularReport,
        title: 'common:account_receivable_regular_report',
        leftIcon: (color, size) => <ScrollDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsAccountPayable,
        routeName: NavigationRoutes.AccountPayableReport,
        component: AccountPayableReport,
        title: 'common:account_payable_report',
        leftIcon: (color, size) => <Receipt2SVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsAccountPayableRegular,
        routeName: NavigationRoutes.AccountPayableRegularReport,
        component: AccountPayableRegularReport,
        title: 'common:account_payable_regular_report',
        leftIcon: (color, size) => <ReceiptDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsTour,
        routeName: NavigationRoutes.TourReport,
        component: TourReport,
        title: 'common:tour_report',
        leftIcon: (color, size) => <SuitcaseSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsCashMutation,
        routeName: NavigationRoutes.CashMutationReport,
        component: CashMutationReport,
        title: 'common:cash_mutation_report',
        leftIcon: (color, size) => <WalletDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsBankMutation,
        routeName: NavigationRoutes.BankMutationReport,
        component: BankMutationReport,
        title: 'common:bank_mutation_report',
        leftIcon: (color, size) => <BankDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsIncome,
        routeName: NavigationRoutes.IncomeReport,
        component: IncomeReport,
        title: 'common:income_report',
        leftIcon: (color, size) => (
          <DollarTransactionSVG {...{ color, size }} />
        ),
      },
      {
        permission: AuthorizationRules.ReportsProfitLossMutation,
        routeName: NavigationRoutes.ProfitLossReport,
        component: IncomeStatementReport,
        title: 'common:income_statement_report',
        leftIcon: (color, size) => (
          <DollarTransactionSVG {...{ color, size }} />
        ),
      },
      {
        permission: AuthorizationRules.ReportsFlight,
        routeName: NavigationRoutes.FlightReport,
        component: FlightReport,
        title: 'common:flight_report',
        leftIcon: (color, size) => <AeroplaneDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsHotel,
        routeName: NavigationRoutes.HotelReport,
        component: HotelReport,
        title: 'common:hotel_report',
        leftIcon: (color, size) => <BedDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsAgentMutation,
        routeName: NavigationRoutes.AgentMutationReport,
        component: AgentMutationReport,
        title: 'common:agent_mutation_report',
        leftIcon: (color, size) => <UserDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsCustomerMutation,
        routeName: NavigationRoutes.CustomerMutationReport,
        component: CustomerMutationReport,
        title: 'common:customer_mutation_report',
        leftIcon: (color, size) => <UserDocSVG {...{ color, size }} />,
      },
      //TODO: get acl
      {
        permission: AuthorizationRules.ReportsProject,
        routeName: NavigationRoutes.ProjectReport,
        component: ProjectListReport,
        title: 'common:project_report',
        leftIcon: (color, size) => <ProjectSVG {...{ color, size }} />,
      },
      //TODO: get acl
      {
        permission: AuthorizationRules.ReportsTransactionMutation,
        routeName: NavigationRoutes.TransactionReport,
        component: TransactionReport,
        title: 'common:transaction_report',
        leftIcon: (color, size) => <ScrollDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsEmployeeCommission,
        routeName: NavigationRoutes.EmployeeComissionReport,
        component: EmployeeCommissionReport,
        title: 'common:commission',
        leftIcon: (color, size) => <ScrollDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsEmployeeSaleBonus,
        routeName: NavigationRoutes.SalesBonusReport,
        component: SalesBonusReport,
        title: 'common:sales-bonus-report',
        leftIcon: (color, size) => <ScrollDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsEmployeeNonSaleBonus,
        routeName: NavigationRoutes.NonSalesBonusReport,
        component: NonSalesBonusReport,
        title: 'common:non-sales-bonus-report',
        leftIcon: (color, size) => <ScrollDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsPassportTravelDocument,
        routeName: NavigationRoutes.PassportReport,
        component: PassportReport,
        title: 'common:passport-report',
        leftIcon: (color, size) => <ScrollDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsVisaTravelDocument,
        routeName: NavigationRoutes.VisaReport,
        component: VisaReport,
        title: 'common:visa-report',
        leftIcon: (color, size) => <ScrollDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsApecCardTravelDocument,
        routeName: NavigationRoutes.ApecCardReport,
        component: ApecCardReport,
        title: 'common:apec-card-report',
        leftIcon: (color, size) => <ScrollDocSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ReportsInsuranceTravelDocument,
        routeName: NavigationRoutes.InsuranceReport,
        component: InsuranceReport,
        title: 'common:insurance-report',
        leftIcon: (color, size) => <ScrollDocSVG {...{ color, size }} />,
      },
    ],
  },

  {
    title: 'common:user_management',
    children: [
      {
        permission: AuthorizationRules.CustomersPage,
        routeName: NavigationRoutes.CustomersList,
        component: CustomerList,
        title: 'common:customer',
        leftIcon: (color, size) => <UserSquareSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.AgentsPage,
        routeName: NavigationRoutes.AgentsList,
        component: AgentList,
        title: 'common:agent',
        leftIcon: (color, size) => (
          <IdentificationBadgeSVG {...{ color, size }} />
        ),
      },

      {
        permission: AuthorizationRules.GuestsPage,
        routeName: NavigationRoutes.GuestsList,
        title: 'common:guest',
        component: GuestList,
        leftIcon: (color, size) => <UsersThreeSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.PreferenceGroupsPage,
        routeName: NavigationRoutes.PreferenceTagsList,
        component: PreferenceTagList,
        title: 'common:preference_tag',
        leftIcon: (color, size) => <TagSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.EmployeesPage,
        routeName: NavigationRoutes.EmployeesList,
        component: EmployeeList,
        title: 'common:employee',
        leftIcon: (color, size) => <UserSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.RolesPage,
        routeName: NavigationRoutes.RolesList,
        component: RoleList,
        title: 'common:role',
        leftIcon: (color, size) => <RoleSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ApprovalsPage,
        routeName: NavigationRoutes.ApprovalMastersList,
        component: ApprovalMasterList,
        title: 'common:approval_master',
        leftIcon: (color, size) => <ChecksSVG {...{ color, size }} />,
      },
    ],
  },

  {
    title: 'common:services',
    children: [
      {
        permission: AuthorizationRules.AirlinesPage,
        routeName: NavigationRoutes.AirlinesList,
        component: AirlineList,
        title: 'common:airline',
        leftIcon: (color, size) => <AeroplaneSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.HotelsPage,
        routeName: NavigationRoutes.HotelsList,
        component: HotelList,
        title: 'common:hotel',
        leftIcon: (color, size) => <BedSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.CruisesPage,
        routeName: NavigationRoutes.CruisesList,
        component: CruiseList,
        title: 'common:cruise',
        leftIcon: (color, size) => <BoatSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ActivitiesPage,
        routeName: NavigationRoutes.ActivitiesList,
        component: ActivityList,
        title: 'common:other',
        leftIcon: (color, size) => <BinocularSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.TourCategoriesPage,
        routeName: NavigationRoutes.TourCategoryList,
        component: TourCategoryList,
        title: 'common:tour_category',
        leftIcon: (color, size) => <SuitcaseSVG {...{ color, size }} />,
      },
    ],
  },

  {
    title: 'common:finances',
    children: [
      {
        permission: AuthorizationRules.CommissionMastersPage,
        routeName: NavigationRoutes.CommissionList,
        title: 'common:commission',
        component: CommissionList,
        leftIcon: (color, size) => <UsersThreeSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.BonusPeriodsPage,
        routeName: NavigationRoutes.BonusPeriodList,
        component: BonusPeriodList,
        title: 'common:bonus-period',
        leftIcon: (color, size) => <DollarSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.TransactionCategoriesPage,
        routeName: NavigationRoutes.TransactionCategoriesList,
        component: TransactionCategoryList,
        title: 'common:transaction_category',
        leftIcon: (color, size) => <FoldersSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.ChequeGirosPage,
        routeName: NavigationRoutes.ChequeGirosList,
        component: ChequeGiroList,
        title: 'common:cheque_giro',
        leftIcon: (color, size) => <NotePencilSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.PaymentChannelsPage,
        routeName: NavigationRoutes.PaymentChannelsList,
        component: PaymentChannelList,
        title: 'common:payment_channel',
        leftIcon: (color, size) => <CardHolderSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.CashAccountsPage,
        routeName: NavigationRoutes.CashAccountsList,
        component: CashAccountList,
        title: 'common:cash_account',
        leftIcon: (color, size) => <WalletSVG {...{ color, size }} />,
      },
      {
        permission: AuthorizationRules.BankAccountsPage,
        routeName: NavigationRoutes.BankAccountsList,
        component: BankAccountList,
        title: 'common:bank_account',
        leftIcon: (color, size) => <BankSVG {...{ color, size }} />,
      },
    ],
  },

  // Approval
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ApprovalItemsView,
    routeName: NavigationRoutes.ApprovalItemsView,
    component: ApprovalView,
  },

  // Sales
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.FlightSalesCreate,
    routeName: NavigationRoutes.TicketSalesCreate,
    component: TicketSaleCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.FlightSalesView,
    routeName: NavigationRoutes.TicketSalesView,
    component: TicketSaleView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.HotelSalesCreate,
    routeName: NavigationRoutes.HotelSalesCreate,
    component: HotelSaleCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.HotelSalesView,
    routeName: NavigationRoutes.HotelSalesView,
    component: HotelSaleView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CruiseSalesCreate,
    routeName: NavigationRoutes.CruiseSalesCreate,
    component: CruiseSaleCreate,
  },

  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CruiseSalesView,
    routeName: NavigationRoutes.CruiseSalesView,
    component: CruiseSaleView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ActivitySalesCreate,
    routeName: NavigationRoutes.ActivitySalesCreate,
    component: ActivitySaleCreate,
  },

  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ActivitySalesView,
    routeName: NavigationRoutes.ActivitySalesView,
    component: ActivitySaleView,
  },

  //travel-documents
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.DocumentSalesCreate,
    routeName: NavigationRoutes.TravelDocumentSalesCreate,
    component: TravelDocumentSalesCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.DocumentSalesView,
    routeName: NavigationRoutes.TravelDocumentSalesView,
    component: TravelDocumentSalesView,
  },

  //visa document
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.VisaDocumentsCreate,
    routeName: NavigationRoutes.VisaDocumentCreate,
    component: VisaDocumentCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.VisaDocumentsView,
    routeName: NavigationRoutes.VisaDocumentView,
    component: VisaDocumentView,
  },

  // Orders
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.FlightPurchasesCreate,
    routeName: NavigationRoutes.FlightPurchasesCreate,
    component: TicketOrderCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.FlightPurchasesView,
    routeName: NavigationRoutes.FlightPurchasesView,
    component: TicketOrderView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.HotelPurchasesCreate,
    routeName: NavigationRoutes.HotelPurchasesCreate,
    component: HotelOrderCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.HotelPurchasesView,
    routeName: NavigationRoutes.HotelPurchasesView,
    component: HotelOrderView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CruisePurchasesCreate,
    routeName: NavigationRoutes.CruisePurchasesCreate,
    component: CruisePurchaseCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CruisePurchasesView,
    routeName: NavigationRoutes.CruisePurchasesView,
    component: CruisePurchaseView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.DocumentPurchasesCreate,
    routeName: NavigationRoutes.DocumentPurchasesCreate,
    component: TravelDocumentOrderCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.DocumentPurchasesView,
    routeName: NavigationRoutes.DocumentPurchasesView,
    component: TravelDocumentOrderView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ActivityPurchasesCreate,
    routeName: NavigationRoutes.ActivityPurchasesCreate,
    component: ActivityPurchaseCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ActivityPurchasesView,
    routeName: NavigationRoutes.ActivityPurchasesView,
    component: ActivityPurchaseView,
  },

  // Tour
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ToursCreate,
    routeName: NavigationRoutes.TourCreate,
    component: TourCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ToursView,
    routeName: NavigationRoutes.TourView,
    component: TourView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.TourSalesCreate,
    routeName: NavigationRoutes.TourSalesCreate,
    component: TourSaleCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.TourSalesView,
    routeName: NavigationRoutes.ToursalesView,
    component: TourSaleView,
  },

  // Project
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ProjectsCreate,
    routeName: NavigationRoutes.ProjectCreate,
    component: ProjectCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ProjectsView,
    routeName: NavigationRoutes.ProjectView,
    component: ProjectView,
  },

  // Product
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ProductsCreate,
    routeName: NavigationRoutes.ProductsCreate,
    component: ProductListCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ProductsView,
    routeName: NavigationRoutes.ProductsView,
    component: ProductListView,
  },

  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ProductPurchasesCreate,
    routeName: NavigationRoutes.ProductPurchasesCreate,
    component: ProductOrderCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ProductPurchasesView,
    routeName: NavigationRoutes.ProductPurchasesView,
    component: ProductOrderView,
  },

  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ProductSalesCreate,
    routeName: NavigationRoutes.ProductSalesCreate,
    component: ProductSaleCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ProductSalesView,
    routeName: NavigationRoutes.ProductSalesView,
    component: ProductSaleView,
  },

  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ProductAdjustmentsCreate,
    routeName: NavigationRoutes.ProductAdjustmentCreate,
    component: ProductAdjustmentCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ProductAdjustmentsView,
    routeName: NavigationRoutes.ProductAdjustmentView,
    component: ProductAdjustmentView,
  },
  //Refund
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.RefundsCreate,
    routeName: NavigationRoutes.RefundCreate,
    component: RefundCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.RefundsView,
    routeName: NavigationRoutes.RefundView,
    component: RefundView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ReleasePurchasesView,
    routeName: NavigationRoutes.RefundReleaseAgentView,
    component: RefundReleaseAgentView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ReleaseSalesView,
    routeName: NavigationRoutes.RefundReleaseUserView,
    component: RefundReleaseUserView,
  },

  // Transaction
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.AccountPayablesCreate,
    routeName: NavigationRoutes.AccountPayablesCreate,
    component: AccountPayableCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.AccountPayablesView,
    routeName: NavigationRoutes.AccountPayablesView,
    component: AccountPayableView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.AccountReceivablesCreate,
    routeName: NavigationRoutes.AccountReceivablesCreate,
    component: AccountReceivableCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.AccountReceivablesView,
    routeName: NavigationRoutes.AccountReceivablesView,
    component: AccountReceivableView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ReceiptsCreate,
    routeName: NavigationRoutes.ReceiptsCreate,
    component: ReceiptCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ReceiptsView,
    routeName: NavigationRoutes.ReceiptsView,
    component: ReceiptView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.OrderAdjustmentsCreate,
    routeName: NavigationRoutes.OrderAdjustmentCreate,
    component: OrderAdjustmentCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.OrderAdjustmentsView,
    routeName: NavigationRoutes.OrderAdjustmentView,
    component: OrderAdjustmentView,
  },

  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ChequeNotesView,
    routeName: NavigationRoutes.ChequeGiroClearingsView,
    component: ChequeGiroClearingsView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.BalanceAdjustmentsCreate,
    routeName: NavigationRoutes.BalanceAdjustmentsCreate,
    component: BalanceAdjustmentsCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.BalanceAdjustmentsView,
    routeName: NavigationRoutes.BalanceAdjustmentsView,
    component: BalanceAdjustmentsView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.BankTransactionsCreate,
    routeName: NavigationRoutes.BankTransactionsCreate,
    component: BankTransactionsCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.BankTransactionsView,
    routeName: NavigationRoutes.BankTransactionsView,
    component: BankTransactionsView,
  },

  {
    title: '',
    hide: true,
    permission: AuthorizationRules.TransfersCreate,
    routeName: NavigationRoutes.TransfersCreate,
    component: TransfersCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.TransfersView,
    routeName: NavigationRoutes.TransfersView,
    component: TransfersView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CashTransactionsCreate,
    routeName: NavigationRoutes.CashTransactionsCreate,
    component: CashTransactionsCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CashTransactionsView,
    routeName: NavigationRoutes.CashTransactionsView,
    component: CashTransactionsView,
  },

  // Report
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ReportsTour,
    routeName: NavigationRoutes.TourDetailReport,
    component: ReportTourDetail,
  },

  // User Management
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CustomersCreate,
    routeName: NavigationRoutes.CustomersCreate,
    component: CustomerCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CustomersView,
    routeName: NavigationRoutes.CustomersView,
    component: CustomerView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.AgentsCreate,
    routeName: NavigationRoutes.AgentsCreate,
    component: AgentCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.AgentsView,
    routeName: NavigationRoutes.AgentsView,
    component: AgentView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.GuestsCreate,
    routeName: NavigationRoutes.GuestsCreate,
    component: GuestCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.GuestsView,
    routeName: NavigationRoutes.GuestsView,
    component: GuestView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CommissionMastersCreate,
    routeName: NavigationRoutes.CommissionCreate,
    component: CommissionCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CommissionMastersView,
    routeName: NavigationRoutes.CommissionView,
    component: CommissionView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.PreferenceGroupsCreate,
    routeName: NavigationRoutes.PreferenceTagsCreate,
    component: PreferenceTagCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.PreferenceGroupsView,
    routeName: NavigationRoutes.PreferenceTagsView,
    component: PreferenceTagView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.EmployeesCreate,
    routeName: NavigationRoutes.EmployeesCreate,
    component: EmployeeCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.EmployeesView,
    routeName: NavigationRoutes.EmployeesView,
    component: EmployeeView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.RolesCreate,
    routeName: NavigationRoutes.RolesCreate,
    component: RoleCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.RolesView,
    routeName: NavigationRoutes.RolesView,
    component: RoleView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ApprovalsCreate,
    routeName: NavigationRoutes.ApprovalMastersCreate,
    component: ApprovalMasterCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ApprovalsView,
    routeName: NavigationRoutes.ApprovalMastersView,
    component: ApprovalMasterView,
  },

  // Service
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.AirlinesCreate,
    routeName: NavigationRoutes.AirlinesCreate,
    component: AirlineCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.AirlinesView,
    routeName: NavigationRoutes.AirlinesView,
    component: AirlineView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.HotelsCreate,
    routeName: NavigationRoutes.HotelsCreate,
    component: HotelCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.HotelsView,
    routeName: NavigationRoutes.HotelsView,
    component: HotelView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CruisesCreate,
    routeName: NavigationRoutes.CruisesCreate,
    component: CruiseCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CruisesView,
    routeName: NavigationRoutes.CruisesView,
    component: CruiseView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ActivitiesCreate,
    routeName: NavigationRoutes.ActivitiesCreate,
    component: ActivityCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ActivitiesView,
    routeName: NavigationRoutes.ActivitiesView,
    component: ActivityView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.TourCategoriesCreate,
    routeName: NavigationRoutes.TourCategoryCreate,
    component: TourCategoryCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.TourCategoriesView,
    routeName: NavigationRoutes.TourCategoryView,
    component: TourCategoryView,
  },

  // Finance
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.TransactionCategoriesCreate,
    routeName: NavigationRoutes.TransactionCategoriesCreate,
    component: TransactionCategoryCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.TransactionCategoriesView,
    routeName: NavigationRoutes.TransactionCategoriesView,
    component: TransactionCategoryView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ChequeGirosCreate,
    routeName: NavigationRoutes.ChequeGirosCreate,
    component: ChequeGiroCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.ChequeGirosView,
    routeName: NavigationRoutes.ChequeGirosView,
    component: ChequeGiroView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.PaymentChannelsCreate,
    routeName: NavigationRoutes.PaymentChannelsCreate,
    component: PaymentChannelCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.PaymentChannelsView,
    routeName: NavigationRoutes.PaymentChannelsView,
    component: PaymentChannelView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CashAccountsCreate,
    routeName: NavigationRoutes.CashAccountsCreate,
    component: CashAccountCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.CashAccountsView,
    routeName: NavigationRoutes.CashAccountsView,
    component: CashAccountView,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.BankAccountsCreate,
    routeName: NavigationRoutes.BankAccountsCreate,
    component: BankAccountCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.BankAccountsView,
    routeName: NavigationRoutes.BankAccountsView,
    component: BankAccountView,
  },

  {
    title: '',
    hide: true,
    permission: AuthorizationRules.BonusPeriodsCreate,
    routeName: NavigationRoutes.BonusPeriodCreate,
    component: BonusPeriodCreate,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.BonusPeriodsView,
    routeName: NavigationRoutes.BonusPeriodView,
    component: BonusPeriodView,
  },

  // Other
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.NoAuthorization,
    routeName: NavigationRoutes.ChangePassword,
    component: ChangePassword,
  },
  {
    title: '',
    hide: true,
    permission: AuthorizationRules.NoAuthorization,
    routeName: NavigationRoutes.Reschedule,
    component: Reschedule,
  },
] as const;

export default routes;
